import _ from "lodash";
import {
    FETCH_META_DATA,
    FETCH_META_DATA_QUERYPARAM,
    FETCH_PUBLIC_META_DATA,
    GET_NOTIFICATION_COUNTER,
    GET_NOTIFICATION_COUNTER_CLEAR,
    SHOW_CONTACT_US,
    SIDEBAR_TOGGLE,
    CREATE_FIRST_QUERY,
    TOGGLE_TRANSLATE,
    CHANGE_TRANSLATE,
    PACKAGE_UPGRADE_POPUP,
    SET_PUBLIC_ACCESS_TOKEN,
    SHOW_CONFIGURE_POST,
    TOGGLE_GET_STARTED,
    IS_SWITCH_COMPANY_PRESENT,
    GET_PROGRESS,
    HIDE_GETTING_STARTED,
    CONFIGURE_PROGRESS,
    ROUTING_PAGE,
    COMPANY_DETAILS,
    SSE_EVENTS,
    SSE_TICKET_EVENTS,
    NOTIFICATION_COUNTER_EVENTS,
    STEPS_COMPLETED,
} from "../actions/globalAction";
import { isFulfilled, setLocalStorageVars, formatPublications } from "./reducerUtils";
import { SHOW_CONTACT_US_LOADER, TOGGLE_VIRALITY_MODE } from "../actions/globalAction";
import { trialPeriodCheck } from "../components/MainContent/Reports/CreateModal/utils";

const urlsInfo = {
    // reports
    "/createreports": { pageLevelCheck: true, redirectPathIfInvalid: "/reports", propertyToCheck: "number_of_reports" },

    // alerts
    "/createalerts": { pageLevelCheck: true, redirectPathIfInvalid: "/alerts", propertyToCheck: "number_of_alerts" },

    // dashboards
    "/dashboard/createdashboard": { pageLevelCheck: true, redirectPathIfInvalid: "/dashboard", propertyToCheck: "custom_dashboard" },
    "/advance-dashboard/createdashboard": {
        pageLevelCheck: true,
        redirectPathIfInvalid: "/advanced-chart-dashboard",
        propertyToCheck: "advance_custom_dashboard",
    },

    // owned-page-analytics
    "/owned-page": { pageLevelCheck: true, redirectPathIfInvalid: "/home", propertyToCheck: "owned_page_analytics" },

    // historic
    //   "/data/historic-data": { pageLevelCheck: true, redirectPathIfInvalid: "/data", propertyToCheck: "historic_data" },
};

const globalReducer = (
    state = {
        publicAccessToken: null,
        company: undefined,
        createFirstQuery: false,
        system_packages: null,
        freeTrialDaysLeft: null,
        filterOptions: undefined,
        notificationCounter: null,
        notificationModalClick: false,
        company_created_date: null,
        userCreationDate: null,
        imageUploadedUrl: null,
        dataUsageHistory: 0,
        dataWordCloud: null,
        packageObj: null,
        dataUsageCountryWise: null,
        listNotifications: [],
        dataUsageCurrent: null,
        show_contactus: false,
        contactUs_loader: false,
        influencersList: [],
        themeMode: "",
        userEmail: null,
        user: null,
        viralityMode: false,
        sidebarExpanded: true,
        command_center: { enable: false },
        newAccessToken: "",
        switchCompanyAvailable: false,
        showGettingStarted: true,
        progressFields: {},
        companyDetails: null,
        //googletranslate
        googlelang:
            sessionStorage.getItem("selectedLanguage") && sessionStorage.getItem("selectedLanguage") !== "null"
                ? sessionStorage.getItem("selectedLanguage")
                : "en",
        translateToggle:
            sessionStorage.getItem("googleTranslate") && ["true", "false"].includes(sessionStorage.getItem("googleTranslate"))
                ? sessionStorage.getItem("googleTranslate") === "true"
                    ? true
                    : false
                : false,
        urlsInfo,
        packageUpgradePopupData: null,

        showGetStarted: false,
        route: {
            from: "",
            to: "",
        },
        userStatus: "online",
        sseData: {},
        sseTicket: undefined,
        stepsCompleted: [],
        googleClientId: "626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com",
    },
    action,
) => {
    switch (action.type) {
        case CREATE_FIRST_QUERY:
            return { ...state, createFirstQuery: action.payload };
        case TOGGLE_TRANSLATE:
            return { ...state, translateToggle: !state.translateToggle };
        case CHANGE_TRANSLATE:
            return { ...state, googlelang: action.payload };

        case GET_NOTIFICATION_COUNTER: {
            state = {
                ...state,
                notificationCounter: action.payload,
            };
            break;
        }

        case GET_NOTIFICATION_COUNTER_CLEAR: {
            // console.log("ffddffddfdffddf",action.payload)
            state = {
                ...state,
                notificationCounter: action.payload.data.deleted,
                notificationModalClick: true,
            };
            break;
        }

        case NOTIFICATION_COUNTER_EVENTS: {
            console.log("firstprevProps", action.payload);
            state = {
                ...state,
                notificationCounter: action.payload + 1,
            };
            break;
        }

        // Fetching MetaData

        case isFulfilled(FETCH_META_DATA_QUERYPARAM): {
            let queryParam = action.payload.queryParam;
            let paramProp = action.payload[queryParam] || state[queryParam];
            let profilePic = action.payload.user.profile_pic;
            let all_companies = action.payload.all_companies;
            let interactive_help_enabled = action.payload.user.interactive_help_enabled;
            if (paramProp) {
                return {
                    ...state,
                    [queryParam]: paramProp,
                    profilePic,
                    all_companies,
                    interactive_help_enabled,
                };
            }
            break;
        }
        case "SET_IMAGE_URL": {
            return { ...state, imageUploadedUrl: action.payload.location };
        }
        case "SWITCH_ACCOUNT_DETAILS": {
            return { ...state, newAccessToken: action.payload };
        }

        case "SET_DATA_USAGE_HISTORY": {
            return { ...state, dataUsageHistory: action.payload ? action.payload : 0 };
        }

        case "SET_DATA_WORD_CLOUD": {
            return { ...state, dataWordCloud: action.payload };
        }

        case "SET_DATA_USAGE_COUNTRYWISE": {
            return { ...state, dataUsageCountryWise: action.payload };
        }

        case "SET_NOTIFICATIONS_LIST": {
            let listNotifications;
            if (action.payload.length > 0) {
                listNotifications = [...action.payload, ...state.listNotifications];

                listNotifications?.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                }) || [];
            } else {
                listNotifications = state.listNotifications;
            }

            const result = [];
            const map = new Map();
            for (const item of listNotifications) {
                if (!map.has(item.id)) {
                    map.set(item.id, true); // set any value to Map
                    result.push(item);
                }
            }

            return { ...state, listNotifications: result };
        }

        // case "SET_DATA_USAGE": {
        //     return { ...state, dataUsageCurrent: action.payload.result[0] };
        // }

        case "SET_DATA_USAGE": {
            const dataUsageCurrent = action.payload.result.find((item) => item.type === "data_pull");
            if (dataUsageCurrent) {
                return { ...state, dataUsageCurrent };
            }
            break;
        }

        case isFulfilled(FETCH_META_DATA): {
            // console.log("first", action.payload);
            const themeMode = action.payload.company.theme_mode;
            const interactive_help_enabled = action.payload.user.interactive_help_enabled;
            localStorage.setItem("themeMode", themeMode);
            localStorage.setItem("interactive_help_enabled", interactive_help_enabled);
            document.getElementsByTagName("body")[0].setAttribute("data-theme", themeMode);

            localStorage.setItem("userId", action.payload.user_id);
            let all_companies = action.payload.all_companies;
            let search_analytics = action.payload.global_configs.search_analytics.config_json;
            let company_created_date = action.payload.created_date_company;
            let user_created_date = action.payload.user_created_date;

            let company = action.payload.company || state.company;
            let packageObj = action.payload.package || state.packageObj;
            let addons = action.payload.addons || state.addons;
            let user = action.payload.user;
            let userCreationDate = (action.payload.user && action.payload.user.user_created_date) || state.userCreationDate;
            let filterOptions = {
                countries: action.payload.countries,
                languages: action.payload.languages,
                platforms: action.payload.platforms,
                topics: action.payload.topics,
                publications: formatPublications(JSON.parse(JSON.stringify(action.payload.publications))) || [],
                publicationsCaps: action.payload.publications || [],
                trends_supported_country: action.payload.trends_supported_country,
            };
            let filterKeyword = action.payload.customQuery;

            let auto_push_enabled = action.payload.auto_push_enabled;
            localStorage.setItem("influencersList", JSON.stringify(action.payload.influencers));
            let profilePic = action.payload.user.profile_pic;
            let userEmail = action.payload.email;
            let userName = action.payload.username;
            let system_packages = action.payload.system_packages;
            const freeTrialDaysLeft = trialPeriodCheck(system_packages, company_created_date, action.payload.company.user_timezone_name);
            let newState = {
                ...state,
                system_packages,
                freeTrialDaysLeft,
                influencersList: action.payload.influencers,
                company_created_date,
                company,
                filterOptions,
                filterKeyword,
                all_companies,
                search_analytics,
                auto_push_enabled,
                user_created_date,
                themeMode,
                userEmail,
                userName,
                interactive_help_enabled,
                profilePic,
                user,
                packageObj,
                addons,
                userCreationDate,
                command_center: action.payload.command_center,
                userStatus: action.payload.user.active_status,
            };
            setLocalStorageVars({ company, filterOptions });
            return newState;
        }

        case isFulfilled(FETCH_PUBLIC_META_DATA): {
            let company = action.payload.company || state.company;
            let newState = {
                ...state,
                company,
            };
            setLocalStorageVars({ company });
            return newState;
        }

        case SET_PUBLIC_ACCESS_TOKEN:
            return {
                ...state,
                publicAccessToken: action.payload,
            };

        case SHOW_CONTACT_US: {
            return { ...state, show_contactus: action.payload };
        }

        case SHOW_CONTACT_US_LOADER: {
            return { ...state, contactUs_loader: action.payload };
        }
        case HIDE_GETTING_STARTED: {
            return { ...state };
        }
        case GET_PROGRESS: {
            let showGettingStarted = true;
            if (action.payload && action.payload.hide_getting_started) showGettingStarted = false;
            return { ...state, progressFields: action.payload, showGettingStarted };
        }
        case CONFIGURE_PROGRESS: {
            return { ...state };
        }

        case TOGGLE_VIRALITY_MODE: {
            state = { ...state, viralityMode: !state.viralityMode };
            break;
        }

        case SIDEBAR_TOGGLE: {
            if (action.payload !== undefined) state = { ...state, sidebarExpanded: action.payload };
            else state = { ...state, sidebarExpanded: !state.sidebarExpanded };
            break;
        }
        case PACKAGE_UPGRADE_POPUP: {
            state = { ...state, packageUpgradePopupData: action.payload };
            break;
        }

        case SHOW_CONFIGURE_POST:
            return (state = {
                ...state,
                showConfigureFbPost: action.payload,
            });

        case IS_SWITCH_COMPANY_PRESENT:
            return (state = {
                ...state,
                switchCompanyAvailable: action.payload,
            });

        case ROUTING_PAGE:
            return (state = {
                ...state,
                route: action.payload,
            });

        case TOGGLE_GET_STARTED:
            state = { ...state, showGetStarted: action.payload };
            break;
        case isFulfilled(COMPANY_DETAILS):
            state = { ...state, companyDetails: action.payload };
            break;

        case "SSE_EVENTS": {
            state = { ...state, sseData: action.payload };
            break;
        }

        case "SSE_TICKET_EVENTS": {
            state = { ...state, sseTicket: action.payload };
            break;
        }

        case STEPS_COMPLETED:
            return { ...state, stepsCompleted: [...state.stepsCompleted, action.payload] };

        case "CHANGE_GOOGLE_CLIENT_ID":
            return { ...state, googleClientId: action.payload || "626488198253-v37qlu0s8mc6qt43jj6u2k1asfqfvu7e.apps.googleusercontent.com" };

        default:
            return state;
    }
    return state;
};

export default globalReducer;
